import { createContext, useContext, useState, useEffect } from 'react';
import en from '../locales/en';
import ar from '../locales/ar';

const LocaleContext = createContext();

const translations = {
  en,
  ar,
};

const rtlLanguages = ['ar'];

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('locale') || 'en';
  });

  const isRTL = rtlLanguages.includes(locale);

  useEffect(() => {
    localStorage.setItem('locale', locale);
    
    // Update document direction
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = locale;
    
    // Update font for Arabic
    if (locale === 'ar') {
      document.documentElement.style.fontFamily = "'Noto Sans Arabic', 'Tajawal', sans-serif";
    } else {
      document.documentElement.style.fontFamily = "'Geist Sans', 'Inter', sans-serif";
    }
  }, [locale, isRTL]);

  const changeLocale = (newLocale) => {
    if (translations[newLocale]) {
      setLocale(newLocale);
    }
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[locale];
    
    for (const k of keys) {
      value = value?.[k];
      if (!value) break;
    }
    
    return value || key;
  };

  const value = {
    locale,
    changeLocale,
    t,
    isRTL,
    availableLocales: Object.keys(translations),
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return context;
}
